import { LedgerStat } from './index'

/** 导入对比弹窗顶部四格摘要 */
export default function CompareSummary({ added, updated, removed, unchanged }) {
  return (
    <div className="ledger-stat-grid" style={{ marginBottom: 16 }}>
      <LedgerStat label="新增" value={added} />
      <LedgerStat label="有变更" value={updated} />
      <LedgerStat label="仅系统有" value={removed} />
      <LedgerStat label="无变化" value={unchanged} />
    </div>
  )
}
